import { Outlet } from "react-router-dom";
import Navbar from "../../components/navbar";
import Footer from "../../components/footer";
import { useState } from "react";
import closeIcon from "../../assets/svg-icons/addWhite.svg";

const Layout = () => {
  const [showBanner, setShowBanner] = useState(true);

  const hideBanner = () => {
    setShowBanner(false);
  };

  return (
    <div className="grid content-between min-h-screen relative">

      {/* TOP ENDORSEMENT BANNER */}
      <div className="w-full">
        {showBanner && (
          <div className="bg-black py-4 md:px-10 xl:px-[100px] justify-between items-center hidden xl:flex">

            <div className="w-full overflow-hidden text-white bg-black md:px-10 xl:px-[100px] text-sm">
              <div className="flex w-fit animate-infinite-scroll hover:[animation-play-state:paused] space-x-10 cursor-default">

                <div className="whitespace-nowrap">
                  🚀 Top infrastructure company endorses Cloudvantage as
                  Africa&apos;s premier hosting provider for infrastructure
                  solutions.
                </div>

              </div>
            </div>

            <div
              onClick={hideBanner}
              className="w-[5%] flex justify-end"
            >
              <img
                src={closeIcon}
                alt="Close banner"
                className="h-5 cursor-pointer rotate-45"
              />
            </div>

          </div>
        )}

        {/* NAVBAR */}
        <Navbar />
      </div>

      {/* PAGE CONTENT */}
      <div className="md:px-10 lg:px-[100px] mt-20 md:mt-0">
        <Outlet />
      </div>

      {/* FOOTER */}
      <Footer />

    </div>
  );
};

export default Layout;